import React from 'react'
import { Box, Typography } from '@mui/material'

function LegalLinks() {
  return (
    <Box sx={{  height: '100%', mt: { xs: '-5rem', md: 0 }, ml: { xs: 1, md: 0 }, display: 'flex', gap: { xs: 1, md: 3 }, flexDirection: 'column', justifyContent: 'start', alignItems: 'start' }} >
      <Typography variant='h5' sx={{ ml: 1, mt: 2 }} >
        Legal
      </Typography>
      <Box sx={{ ml: 2, display: 'flex', flexDirection: 'column', gap: 1, alignItems: 'start' }} >
        <Typography sx={{ fontSize: '0.9rem' }} >Privacy Policy</Typography>
        <Typography sx={{ fontSize: '0.9rem' }} >Return Policy</Typography>
        <Typography sx={{ fontSize: '0.9rem' }} >Terms & Conditions</Typography>
      </Box>
    </Box>
  )
}

export default LegalLinks
